<template>
  <v-card class="userfile mx-0 my-2" flat v-if="!isDeleted">
    <v-layout class="center">
      <v-flex xs12 class="py-1">
        <v-layout align-center v-if="userfile.file_type_id == 3">
          <amaze-userfile-video :userfile="userfile">
            <slot></slot>
          </amaze-userfile-video>
        </v-layout>
        <v-layout align-center v-else>
          <a
            @click.prevent="downloadFile"
            target="_blank"
            class="fileName fileWrapper"
            v-if="userfile.file_type_id !== 6"
          >
            <div>
              <v-btn
                fab
                flat
                :href="filepath"
                target="_blank"
                class="mx-3 fileIcon"
              >
                <v-avatar>
                  <v-progress-circular
                    :indeterminate="true"
                    v-if="downloading"
                  ></v-progress-circular>
                  <v-icon
                    v-else
                    :class="bg"
                    medium
                    color="white"
                    v-html="fileIcon"
                  ></v-icon>
                </v-avatar>
              </v-btn>

            </div>
            <div>
              <div v-if="userfile.description">
                <!-- <p class="ma-0"> -->
                <a target="_blank" class="fileName">{{
                  userfile.name | truncate(40)
                }}</a>

                <!-- </p> -->
                <p class="mb-1 fileDescription">{{ userfile.description }}</p>
              </div>
              <div v-else align-center fill-height>
                <!-- <p class="ma-0"> -->
                <a target="_blank" class="fileName">{{
                  userfile.name | truncate(40)
                }}</a>
                <!-- </p> -->
              </div>
            </div>
          </a>
          <a
            v-else
            target="_blank"
            class="fileName fileWrapper"
            :href="filepath"
          >
            <div>
              <v-btn
                fab
                flat
                :href="filepath"
                target="_blank"
                class="mx-3 fileIcon"
              >
                <v-avatar>
                  <v-icon
                    :class="bg"
                    medium
                    color="white"
                    v-html="fileIcon"
                  ></v-icon>
                </v-avatar>
              </v-btn>
            </div>
            <div>
              <div v-if="userfile.description">
                <!-- <p class="ma-0"> -->
                <a target="_blank" class="fileName" :href="filepath">{{
                  userfile.name | truncate(40)
                }}</a>
                <!-- </p> -->
                <p class="mb-1 fileDescription">{{ userfile.description }}</p>
              </div>
              <div v-else align-center fill-height>
                <!-- <p class="ma-0"> -->
                <a target="_blank" class="fileName" :href="filepath">{{
                  userfile.name | truncate(40)
                }}</a>
                <!-- </p> -->
              </div>
            </div>
          </a>
          <v-spacer></v-spacer>
          <div align-center>
            <slot></slot>
          </div>
        </v-layout>
      </v-flex>

      <v-menu
        auto
        left
        v-if="
          this.$auth.user().id == userfile.user_id ||
          this.$auth.check('uber_admin')
        "
      >
        <v-btn slot="activator" icon>
          <v-icon color="primary">more_vert</v-icon>
        </v-btn>
        <v-list>
          <div
            v-if="
              this.$auth.user().id == userfile.user_id ||
              this.$auth.check('uber_admin')
            "
          >
            <v-list-tile @click="detailsDialog = true">
              <v-list-tile-title>Edit Details</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteFile()">
              <v-list-tile-title>Delete</v-list-tile-title>
            </v-list-tile>
          </div>
        </v-list>
      </v-menu>
    </v-layout>

    <v-flex v-if="imageblob" xs12 class="my-2 py-0">
      <img :src="imageblob" />
    </v-flex>

    <v-dialog v-model="detailsDialog" max-width="400" persistent>
      <v-card>
        <v-card-title>
          <h3>Edit File Details</h3>
        </v-card-title>
        <hr class="thick" />
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Title"
                required
                v-model="shadowFile.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="shadowFile.file_type_id == 6">
              <v-text-field
                label="URL"
                required
                v-model="shadowFile.filename"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                label="Description"
                v-model="shadowFile.description"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveUserfile()">Save Edits</v-btn>
          <v-btn flat outline @click="detailsDialog = !detailsDialog"
            >Cancel and Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';
.userfile {
  width: 100%;
  font-size: 15px;
  background-color: $amaze-yellow-background;
  > div:first-of-type {
    background: $resource-background;
    &:before {
      content: '';
      opacity: 0.72 !important;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
  }
}
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent !important;
  color: $link-hover;
}

.fileIcon {
  &a,
  .v-avatar,
  i {
    &:hover {
      color: $link-hover;
      background-color: $link-hover;
    }
  }
}
.fileWrapper {
  display: flex;
  flex: 1 1 auto;
  justify-content: left;
  align-items: center;
  &:hover {
    a,
    .v-avatar,
    i {
      color: $link-hover;
    }
    i {
      border: none;
      background-color: $link-hover;
    }
  }
}
.fileName {
  font-weight: bold;
  font-size: 15px;
}
.fileDescription {
  font-size: 14px;
  font-weight: normal;
  color: $font-color;
}
.time {
  font-size: 12px;
}
.iconBlue {
  background-color: $icon-blue;
  margin-left: 0 !important;
}
.center {
  align-items: center;
}
</style>
<script>
import AmazeUserfileVideo from '@/components/Widgets/AmazeUserfileVideo'
import fileMixin from '@/mixins/fileMixin.js'
import _ from 'lodash'

export default {
  components: { AmazeUserfileVideo },
  props: ['userfile'],
  mixins: [fileMixin],
  data () {
    return {
      detailsDialog: false,
      previewDialog: false,
      shadowFile: _.cloneDeep(this.userfile),
      isDeleted: false,
      downloading: false,
      imageblob: false
    }
  },
  watch: {
    detailsDialog () {
      this.shadowFile = _.cloneDeep(this.userfile)
    }
  },
  computed: {
    bg () {
      return 'pa-2 iconBlue darker-1'
      /* comment in below for colorful circles
        if (this.userfile.file_type_id === 1) return "pa-2 red darker-2";
        else if (this.userfile.file_type_id === 2) return "pa-2 cyan darker-1";
        else if (this.userfile.file_type_id === 3) return "pa-2 yellow darker-2";
        else if (this.userfile.file_type_id === 4) return "pa-2 green darker-2";
        else if (this.userfile.file_type_id === 5) return "pa-2 blue darker-2";
        else if (this.userfile.file_type_id === 6) return "pa-2 deep-purple lighten-2";
        */
    },
    filepath () {
      let link = ''
      if (this.userfile.file_type_id === this.FILE_TYPE_ID_LINK) {
        link = this.userfile.filename
      } else {
        link = process.env.VUE_APP_FILE_BASE + this.userfile.full_url
      }
      return link
    },
    fileIcon () {
      // URLs aren't handled in the mimeToIcon function.
      if (this.userfile.file_type_id === this.FILE_TYPE_ID_LINK) {
        return 'fas fa-link'
      }

      return 'fas ' + this.mimeToIcon(this.userfile.mime)
    }
  },
  mounted () {
    this.getImage()
  },
  methods: {
    getImage() {
      switch (this.userfile.mime) {
        // Supported image types:
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/tiff':
        case 'image/x-icon':
        case 'image/svg+xml':
        case 'image/webp':
          this.$http
            .get(this.userfile.full_url, { responseType: 'arraybuffer' })
            .then(response => {
              // Turn response into a blob.
              var myBlob = new Blob([response.data])
              // This doesn't seem to work, but just in case it's a browser specific
              // thing, I'll leave it in since it does not appear to negatively
              // impact anything.
              myBlob.name = this.userfile.name
              // Create a file object, and get the URL.
              var file = new File([myBlob], this.userfile.name, {
                type: this.userfile.mime
              })
              this.imageblob = URL.createObjectURL(file)
              this.downloading = false
            })

          break
        default:
          // Don't want anything here.

          break
      }
    },
    downloadFile () {
      if (this.userfile.file_type_id === 6) {
        return
      }
      this.downloading = true
      // We have to make an authenticated GET request to the api.
      // These files are private S3 files, so we use the file manager
      // proxy to authenticate and serve them.
      this.$http
        .get(this.userfile.full_url, { responseType: 'arraybuffer' })
        .then(response => {
          /**
           * 2021-11-18: For AMAZSD-88, the request is that we open PDFs in
           * a new tab instead of automatically downloading it like other
           * file types.
           *
           * I'm basing the solution loosely on: https://stackoverflow.com/a/52273870.
           */
          // Turn response into a blob.
          var myBlob = new Blob([response.data])
          // This doesn't seem to work, but just in case it's a browser specific
          // thing, I'll leave it in since it does not appear to negatively
          // impact anything.
          myBlob.name = this.userfile.name
          // Create a file object, and get the URL.
          var file = new File([myBlob], this.userfile.name, {
            type: this.userfile.mime
          })
          var exportUrl = URL.createObjectURL(file)

          // Overall strategy is to convert response into a data url.
          // Then temporarily attach an anchor, click that to handle
          // file download.
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'

          switch (this.userfile.mime) {
            case 'application/pdf':
            case 'image/jpeg':
              tempLink.setAttribute('target', '_blank')
              break
            default:
              tempLink.setAttribute('download', this.userfile.name)
              break
          }

          tempLink.href = exportUrl
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          this.downloading = false
        })
    },
    saveUserfile () {
      var editData = {
        name: this.shadowFile.name,
        description: this.shadowFile.description
      }

      if (this.userfile.file_type_id === this.FILE_TYPE_ID_LINK) {
        editData.filename = this.shadowFile.filename
      }

      this.$http.put('userfiles/' + this.shadowFile.id, editData).then(
        response => {
          this.detailsDialog = false
          this.userfile = _.cloneDeep(this.shadowFile)
        },
        response => {
          console.log('Error saving file information.')
        }
      )
    },
    deleteFile () {
      this.$http.delete('userfiles/' + this.shadowFile.id).then(
        response => {
          this.isDeleted = true
        },
        response => {
          console.log('Error deleting file.')
        }
      )
    }
  },
  created () {
    this.FILE_TYPE_ID_LINK = 6
  }
}
</script>
